// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import store from './store'
import vue_meta from './plugins/vue-meta'
import vuetify from './plugins/vuetify'

import moment from 'moment'

require('./assets/style.scss')

moment.locale('de')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vue_meta,
  vuetify,
  components: { App },
  render: h => h(App)
}).$mount('#app')
